<template>
  <div :style="{height}" class="generic-gutter" />
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
  },
  computed: {
    height() {
      return _.get(this.component, 'height', '0px')
    },
  },
}
</script>

<style lang="scss" scoped></style>
